// extracted by mini-css-extract-plugin
export default {"overlay":"overlay--FVDcu","container":"container--ewyTq","item":"item--sWJ__","text":"text--TDBB2","item--active":"item--active--oorzV"};